import React from "react";
import clsx from "clsx";

interface ListItem {
  text: string;
  className?: string;
}

type Props = {
  items: ListItem[];
  className?: string;
};

export default function List({ items, className }: Props) {
  return (
    <ul className={clsx("list-disc", "list-inside", className)}>
      {items.map((item, index) => (
        <li key={index} className={item.className}>
          {item.text}
        </li>
      ))}
    </ul>
  );
}
